import { apiFetch } from '../../auth/apiClient';

const XLSX_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

export async function downloadBudgetWorkbook({ fiscalYear, mode, draftPots, unsaved = false, columns }) {
  if (!/^\d{4}-\d{4}$/.test(fiscalYear || '')
    || Number(fiscalYear.slice(5)) !== Number(fiscalYear.slice(0, 4)) + 1
    || !['published', 'draft'].includes(mode)) throw new Error('Choose a fiscal year to export.');

  const query = new URLSearchParams({ fiscalYear, mode });
  const response = await apiFetch(`/api/finance/budget-export-data?${query.toString()}`);
  const snapshot = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(snapshot?.message || (response.status === 409
    ? 'Fiscal budgets are being prepared. Please try again after the update.'
    : 'Unable to export this budget. Please try again.'));
  if (snapshot?.fiscalYear !== fiscalYear || !Array.isArray(snapshot?.pots)) {
    throw new Error('The budget export data could not be read. Please try again.');
  }

  // Load ExcelJS and the workbook builder only when an export is requested.
  const { buildBudgetWorkbook } = await import('./budgetWorkbook');
  const workbook = await buildBudgetWorkbook({ ...snapshot, mode, draftPots, unsaved, columns });
  const buffer = await workbook.xlsx.writeBuffer();
  const url = URL.createObjectURL(new Blob([buffer], { type: XLSX_TYPE }));
  const link = document.createElement('a');
  const filename = `PATH Budget ${fiscalYear}${mode === 'draft' ? ' Draft' : ''}.xlsx`;
  try {
    link.href = url;
    link.download = filename;
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
  } finally {
    link.remove();
    // Let the browser consume the download before releasing its object URL.
    window.setTimeout(() => URL.revokeObjectURL(url), 1000);
  }
  return filename;
}
